import { Menu as ChakraMenu, Image, MenuButton, MenuItem, MenuList, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';
import Router, { useRouter } from 'next/router';
import { useCallback, useEffect, useState } from 'react';
import { useUserDataContextProvider } from 'src/context/UserDataContextProvider';
import { MenuID } from 'src/types';
import { I18nIcon, RiseIcon, TargetIcon } from '../common/Icons/analysisGuide';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var menuList = [{
  path: "".concat(MenuID.analysisGuideTarget),
  icon: TargetIcon
}, {
  path: "".concat(MenuID.analysisGuideDiet),
  icon: RiseIcon
}];
export var Menu = function Menu(_ref) {
  var sideBarWidth = _ref.sideBarWidth;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useRouter = useRouter(),
      locales = _useRouter.locales,
      pathname = _useRouter.pathname;

  var searchParams = useSearchParams();

  var _useUserDataContextPr = useUserDataContextProvider(),
      profile = _useUserDataContextPr.profile;

  var _useState = useState(profile === null || profile === void 0 ? void 0 : profile.locale),
      locale = _useState[0],
      setLocale = _useState[1];

  useEffect(function () {
    if (!(profile !== null && profile !== void 0 && profile.locale)) {
      return;
    }

    if (profile !== null && profile !== void 0 && profile.locale) {
      Router.push({
        pathname: Router.pathname,
        query: Router.query
      }, Router.asPath, {
        locale: profile === null || profile === void 0 ? void 0 : profile.locale
      });
      setLocale(profile.locale);
    }
  }, [profile === null || profile === void 0 ? void 0 : profile.locale]);
  var handleSwitchLanguage = useCallback(function (e) {
    var locale = e.target.dataset.id;
    Router.push({
      pathname: Router.pathname,
      query: Router.query
    }, Router.asPath, {
      locale: locale
    });
    setLocale(locale);
  }, []);
  return /*#__PURE__*/_jsxs(VStack, {
    w: sideBarWidth,
    h: "100vh",
    borderTopWidth: "6px",
    borderBottomWidth: "6px",
    borderTopColor: "cyan.500",
    borderBottomColor: "cyan.500",
    overflow: "visible",
    color: "white",
    fontSize: "sm",
    pos: "relative",
    spacing: 0,
    e2eid: "AnalysisGuide_Menu_VStack",
    children: [/*#__PURE__*/_jsx(Image, {
      width: "12",
      height: "12",
      my: "4",
      alt: "cofit",
      src: "/cofitLogo.png",
      e2eid: "AnalysisGuide_Menu_Image"
    }), menuList.map(function (menu) {
      var isActive = menu.path === pathname;
      return /*#__PURE__*/_jsx(Link, {
        href: "".concat(menu.path, "?").concat(searchParams),
        e2eid: "AnalysisGuide_Menu_Link",
        children: /*#__PURE__*/_jsx(VStack, {
          w: "12",
          h: "12",
          bg: isActive ? 'brand' : '',
          borderRadius: "md",
          justify: "center",
          align: "center",
          e2eid: "AnalysisGuide_Menu_VStack",
          children: /*#__PURE__*/_jsx(menu.icon, {
            boxSize: "6",
            color: isActive ? 'white' : undefined
          })
        })
      }, menu.path);
    }), /*#__PURE__*/_jsx(VStack, {
      w: "14",
      h: "16",
      py: "2",
      pos: "absolute",
      bottom: "4",
      borderTopWidth: "2px",
      borderTopColor: "gray.300",
      align: "center",
      justify: "center",
      e2eid: "AnalysisGuide_Menu_VStack_4",
      children: /*#__PURE__*/_jsxs(ChakraMenu, {
        placement: "right",
        offset: [0, 0],
        e2eid: "AnalysisGuide_Menu_ChakraMenu",
        children: [/*#__PURE__*/_jsxs(MenuButton, {
          w: "full",
          py: "1",
          bg: "rgba(0, 172, 200, 0.08)",
          borderRadius: "md",
          e2eid: "AnalysisGuide_Menu_MenuButton",
          children: [/*#__PURE__*/_jsx(I18nIcon, {
            boxSize: "6",
            cursor: "pointer",
            e2eid: "AnalysisGuide_Menu_I18nIcon"
          }), /*#__PURE__*/_jsx(Text, {
            fontSize: "sm",
            color: "blackAlpha.300",
            e2eid: "AnalysisGuide_Menu_Text",
            children: t("common:locales.".concat(locale, "_brief"), locale)
          })]
        }), /*#__PURE__*/_jsx(MenuList, {
          w: "20",
          borderRadius: "md",
          color: "black",
          e2eid: "AnalysisGuide_Menu_MenuList",
          children: locales.map(function (lo) {
            return /*#__PURE__*/_jsx(MenuItem, {
              h: "10",
              "data-id": lo,
              bg: locale === lo ? 'brand' : '',
              color: locale === lo ? 'white' : 'black',
              onClick: handleSwitchLanguage,
              fontSize: "md",
              e2eid: "AnalysisGuide_Menu_MenuItem",
              children: t("common:locales.".concat(lo), lo)
            }, lo);
          })
        })]
      })
    })]
  });
};